import React, { useEffect } from "react";
import "./heroes.scss";
import sidebarActivePage from "../../stores/sidebarActivePage";
import heroStore from "../../stores/heroStore";
import SnackbarAlert from "../../components/snackbarAlert/snackbarAlert";
import snackbarStore from "../../stores/snackbarStore";
import TwoBreadcrumb from "../../components/breadcrumbs/TwoBreadcrumb";
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  Input,
  InputAdornment,
  InputLabel,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { IoIosAdd } from "react-icons/io";
import { useState } from "react";
import HeroCard from "./heroCard/HeroCard";

const Heroes = () => {
  const defaultStartSlice = 0;
  const defaultEndSlice = 12;
  const HeroStore = heroStore();
  const SnackbarStore = snackbarStore();
  const SidebarActivePage = sidebarActivePage();
  const [searchValue, setSearchValue] = useState("");
  const [filterHeroes, setFilterHeroes] = useState([]);
  const [startSlice, setStartSlice] = useState(defaultStartSlice);
  const [endSlice, setEndSlice] = useState(defaultEndSlice);
  const [activePage, setActivePage] = useState(1);
  const [pageCount, setPageCount] = useState(1);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    SidebarActivePage.setIsActive({ setPage: "Hero Section" });
    await HeroStore.fetchAllHeroes();
    if (SnackbarStore.massage !== "") {
      SnackbarStore.setIsOpen({ value: true });
    }
  };

  useEffect(() => {
    if (HeroStore.heroes) {
      setFilterHeroes(HeroStore.heroes.slice(0).reverse());
      const count = HeroStore.heroes.length / defaultEndSlice;
      setPageCount(parseInt(Math.ceil(count)));
    }
  }, [HeroStore.heroes]);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [activePage]);

  useEffect(() => {
    if (HeroStore.heroes) {
      if (searchValue !== "") {
        // const data = HeroStore.heroes.filter((item) => {
        //   return item.couponName
        //     .toLowerCase()
        //     .includes(searchValue.toLowerCase());
        // });
        const data = HeroStore.heroes;
        setFilterHeroes(data.slice(0).reverse());
        const count = data.length / defaultEndSlice;
        setPageCount(parseInt(Math.ceil(count)));
      } else {
        setFilterHeroes(HeroStore.heroes.slice(0).reverse());
        const count = HeroStore.heroes.length / defaultEndSlice;
        setPageCount(parseInt(Math.ceil(count)));
      }
    }
  }, [searchValue]);

  return (
    <div className="heroes">
      <SnackbarAlert
        isOpen={SnackbarStore.isOpen}
        alertVariant="filled"
        onClose={() => {
          SnackbarStore.setIsOpen({ value: false });
          SnackbarStore.setMassage({ value: "" });
        }}
        massage={SnackbarStore.massage}
      />
      <div className="heading">Hero</div>
      <TwoBreadcrumb
        mainName="Hero"
        mainLink="hero-management"
        activeName="List"
      />
      <div className="btn-right-side flex">
        <Link to="/hero-management/new">
          <Button variant="contained" className="btn" startIcon={<IoIosAdd />}>
            New Hero
          </Button>
        </Link>
      </div>
      <Grid container sx={{ mt: 1 }}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormControl sx={{ width: "100%" }} variant="standard">
            <InputLabel htmlFor="standard-adornment-search">
              <p>Search coupon name</p>
            </InputLabel>
            <Input
              value={searchValue}
              onChange={({ target: { value } }) => setSearchValue(value)}
              endAdornment={
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              }
            />
          </FormControl>
        </Grid>
      </Grid>
      <div className="main">
        <Grid container spacing={2}>
          {!HeroStore.isLoading ? (
            HeroStore.heroes && HeroStore.heroes.length ? (
              HeroStore.heroes
                .slice()
                .reverse()
                .map((item) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item._id}>
                    <HeroCard item={item} />
                  </Grid>
                ))
            ) : (
              <Grid item container>
                <Grid item xs={12}>
                  <div className="noData">No Data</div>
                </Grid>
              </Grid>
            )
          ) : (
            <div className="process">
              <CircularProgress className="cProgress" />
            </div>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default Heroes;
